import { createRouter, createWebHashHistory } from 'vue-router'
import Dashboard from '@/view/dashboard/dashboard/index.vue';
import Calibration from '@/view/calibration/calibration/index.vue';
import Advanced from '@/view/calibration/advanced/index.vue';
import Task from '@/view/task/taskmanagement/index.vue';
import Notification from '@/view/dashboard/notification/index.vue';
import Device from '@/view/device/device/index.vue';
import DeviceDetail from '@/view/device/devicedetail/index.vue';
import Group from '@/view/group/group/index.vue';
import GroupDetail from '@/view/group/groupdetail/index.vue';
import Cloud from '@/view/cloud/cloudtarget/index.vue';
import Login from '@/view/login/index.vue';
import Main from '@/view/main/index.vue';
import { FEATURENAME } from '@/enum/enum';



// const ENV = {
//     dev: {
//         base: './'
//     },
//     // production: {
//     //     base: '/image_utility_cloud/demo/',
//     // }
//     production: {
//         base: './',
//     }
// }

const routes = [
    // UiDemo 元件展示頁僅在開發環境註冊,避免 demo 頁進入正式打包
    // 注意:本專案 NODE_ENV 為自訂值 (prod/staging/dev/mock/adc/dev-online)
    ...((process.env.NODE_ENV === 'dev' || process.env.NODE_ENV === 'mock') ? [{
        path: '/ui',
        name: 'Ui',
        component: () => import('@/components/ui/UiDemo/index.vue'),
    }] : []),
    {
        path: '/login',
        name: FEATURENAME.LOGIN,
        component: Login,
    },
    {

        path: '/',
        redirect: '/main/dashboard',
    },
    {
        path: '/main',
        name: 'Index',
        component: Main,
        children: [{
            path: 'dashboard',
            name: FEATURENAME.DASHBOARD,
            component: Dashboard,
        },
        {
            path: 'dashboard',
            name: FEATURENAME.DASHBOARDDEFAULT,
            component: Dashboard,
        },
        {
            path: 'dashboard/notification',
            name: FEATURENAME.NOTIFICATION,
            component: Notification
        }, {
            path: 'device',
            name: FEATURENAME.DEVICE,
            component: Device
        }, {
            path: 'device/:name/:tabId',
            name: FEATURENAME.DEVICEDETAIL,
            component: DeviceDetail
        }, {
            path: 'group',
            name: FEATURENAME.GROUP,
            component: Group
        }, {
            path: 'group/:name/:tabId',
            name: FEATURENAME.GROUPDETAIL,
            component: GroupDetail
        }, {
            path: 'cloud',
            name: FEATURENAME.CLOUD,
            component: Cloud
        }, {
            path: 'calibration',
            name: FEATURENAME.CALIBRATION,
            component: Calibration,
        }, {
            path: 'calibration',
            name: FEATURENAME.CALIBRATIONDEFAULT,
            component: Calibration,
        },
        {
            path: 'calibration/advanced',
            name: FEATURENAME.ADVANCED,
            component: Advanced,
        }, {
            path: 'calibration/modify/:type/:device/:id',//type=device,group    device=device.id,group.id
            name: FEATURENAME.MODIFY,
            component: Advanced,
        },{
            path: 'tasks/:tabId',
            name: FEATURENAME.TASK,
            component: Task,
        },
        // {
        //     path: 'appointment',
        //     name: FEATURENAME.TASK,
        //     component: Advanced,
        // },
        ]

    },

]

export const router = createRouter({
    // mode: 'history',
    history: createWebHashHistory(),
    // base: ENV.production.base,
    // @ts-ignore 
    routes: routes,
    // @ts-ignore 
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition && to.meta.keepAlive) {
            return savedPosition;
        }
        if (to.hash) {
            return { el: to.hash, behavior: "smooth" };
        } else {
            if(document.getElementById('main-layout-content')){
                document.getElementById('main-layout-content').scrollTo(0, 0);
            }
            return { x: 0, y: 0 };
        }
    },

})

router.beforeEach(() => {
    window.scrollTo(0, 0)
    // ...
})

export default router;